import { SectionDataWithProgress } from '../../../types/compound/progressTypes';
import SkillData from '../../../types/skillData';
import ProgressBar from '../../atoms/progress-bar/ProgressBar';
import SectionList, { SectionRowCurrentSectionData } from '../../molecules/skill-list/SectionList';

interface SectionProgressSidebarContentProps {
  skill: SkillData;
  currentSectionData: SectionRowCurrentSectionData;
  sections: SectionDataWithProgress[];
  currentContentId?: string;
}

export function SectionProgressSidebarContent({
  skill,
  currentSectionData,
  sections,
  currentContentId,
}: SectionProgressSidebarContentProps) {
  const completeSections = sections.filter(section => section.complete).length;

  return (
    <div className="flex flex-col h-full py-6">
      <SectionList
        className="mb-8 overflow-y-scroll"
        sections={sections}
        currentSectionData={currentSectionData}
        skill={skill}
        currentContentId={currentContentId}
      />
      <div className="px-8 mt-auto">
        <ProgressBar
          className="border-t-2 border-b-2 pb-4 pt-3"
          completeSections={completeSections}
          totalSections={sections.length}
        />
      </div>
    </div>
  );
}
